import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UserRolesService } from "../services/user-roles.service";
import { AppConfig } from "../design/app";
@Component({
    selector: 'app-user-unauthorized',
    templateUrl: './user-unauthorized.component.html',
    styleUrls: ['./user-unauthorized.component.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UserUnauthorizedComponent implements OnInit {
  isUserRegistered: boolean = true;
  appConfig: any;
  mainAppUrl: string;
  isInvalidDomain: boolean = false;
  constructor(
    private userRoleService: UserRolesService
  ) {
    this.appConfig = AppConfig;
  }

  ngOnInit(): void {
    this.mainAppUrl = this.appConfig.mainAppUrl;
    this.userRoleService.isUserRegistered$.subscribe((value) => {
      this.isUserRegistered = value;
    });
    this.userRoleService.isInvalidDomain$.subscribe((value) => {
      this.isInvalidDomain = value;
    });
  }

}
